import { FormProvider } from 'react-hook-form';
import { useCreateInternalNews } from './hooks';
import { CreateInternalNewsPresentation } from './presentations';

/**
 * 社内報作成フォームの Container コンポーネント。
 * FormProvider でラップし、フォーム状態を Presentation に接続する。
 */
export const CreateInternalNews: React.FC = () => {
  const {
    state: { methods, isSubmitDisabled, publishMode, files, isFileUploading, isFileUploadDisabled },
    actions: { handleSubmit, handleFilesChange },
  } = useCreateInternalNews();

  return (
    <FormProvider {...methods}>
      <CreateInternalNewsPresentation
        isSubmitDisabled={isSubmitDisabled}
        publishMode={publishMode}
        onSubmit={handleSubmit}
        attachedFiles={files}
        isFileUploading={isFileUploading}
        isFileUploadDisabled={isFileUploadDisabled}
        onFilesChange={handleFilesChange}
      />
    </FormProvider>
  );
};
